exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".react-dialog{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.3);display:flex;align-items:center}.react-dialog__container{max-width:80%;margin:auto;border:1px solid #ddd;border-radius:5px;background:#fff;text-align:center}.react-dialog__header{display:flex;align-items:center;padding:20px;padding-bottom:0}.react-dialog__close-btn{margin-left:auto;cursor:pointer;font-size:2rem}.react-dialog__content{padding:20px 50px}.react-dialog__buttons{display:inline-block;margin-bottom:20px}.react-dialog__buttons>div{padding:10px 40px;display:inline-block;cursor:pointer;border:1px solid #eee}.react-dialog__cancel-btn{margin-left:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/index.css
// module id = 2
// module chunks = 0